import { gql } from 'graphql-tag'

export const AUTO_QUOTE_FIELDS = gql`fragment AutoQuoteFields on AutoQuote {
  id
  effectiveDate
  quoteExpirationDate
  createdAt
  termEffectiveDate
  termExpirationDate
  allowedLicenseStates
  statusInfo {
    status
    reasons {
      kind
      message
    }
  }
  insuredHumans {
    id
    firstName
    middleName
    lastName
    birthdate
    role
    relationshipToPrimary
  }
  unbindableReasons {
    kind
    id
    field
    message
  }
  location {
    streetNumber
    streetName
    unit
    city
    state
    zip
    moratoriumInEffect
  }
  vehicles {
    id
    year
    make
    series
    engine
    vin
    bodyStyle
    enabled
    omissionReason
    annualMiles
    vehicleUse
    vehicleOwnership
    vehicleInLLC
    purchasedOrLeasedNew
    rideshareUse
    notTitledByNamedInsured
    vehicleInTrust
    garagingAddress {
      streetNumber
      streetName
      unit
      city
      state
      zip
      moratoriumInEffect
    }
    leasingCompany {
      id
      vehicleId
      lenderName
      mailingAddress {
        streetLine1
        streetLine2
        city
        state
        zip
      }
    }
    financingCompany {
      id
      vehicleId
      lenderName
      loanNumber
      phoneNumber
      email
      mailingAddress {
        streetLine1
        streetLine2
        city
        state
        zip
      }
    }
    coverages
  }
  drivers {
    id
    ageFirstLicensed
    driverStatus
    ratedOptions
    relationshipToInsured
    insuredHumanRole
    educationLevel
    occupation
    firstName
    middleName
    lastName
    birthdate
    maritalStatus
    hasDriversLicense
    priorInsurance
    hadInsuranceLastThirtyOneDays
    coverageLapseReason
    qualifiesForGoodStudentDiscount
    attendsSchoolOverHundredMilesAway
    drivesHouseholdVehicleRegularly
    licenses {
      id
      status
      number
      state
      gender
      issued
      type
    }
  }
  formSchema
  type
  premiumCents
  hasMultiPolicy
  proratedPremiumCents
  termNumber
  transactionNumber
  createdBy
  policyCoverage
  eDocs
  agent {
    id
    firstName
    lastName
  }
  trusts {
    id
    vehicleIds
    trustName
    trusteeName
    phoneNumber
    email
    einTaxID
    mailingAddress {
      streetLine1
      streetLine2
      city
      state
      zip
    }
  }
  additionalInterests {
    id
    firstName
    lastName
    relationshipToPolicyholder
    email
    phoneNumber
    mailingAddress {
      streetLine1
      streetLine2
      city
      state
      zip
    }
  }
  policy {
    id
    policyNumber
    createdAt
    communicationPreferences {
      mailingAddress {
        streetLine1
        streetLine2
        city
        state
        zip
      }
      id
      allowSMS
      email
      phone
    }
  }
  billing {
    paymentPlan
    allowPaymentPlanChange
    paymentPlanChangeBlockReason
    initialPaymentMethod
    initialPaymentToken
    switchToDirectBillOnBind
    downPaymentPercentage
  }
  documents {
    path
    type
    updatedAt
  }
  account {
    id
  }
  canBind
}`
